import Disclosour from 'components/Disclosour';
import React from 'react'

export default function MiniCard({title,desc,img}) {
  return (
    <div className="flex items-center p-5 space-x-5 shadow-md xl:py-12 xl:px-14 rounded-2xl xl:w-[580px]">
      <img
        crossOrigin='anonymous'
        src={img}
        alt={desc}
        className="rounded-2xl h-[156px] w-[156px]"
        width={156}
        height={156}
      />
      <div className="wrapperDetail">
        <h1 className="font-bold text-primary">{title}</h1>
        <Disclosour label="Selengkapnya" miniCard>
          <p className="text-sm font-bold text-postLabel">{desc}</p>
        </Disclosour>
      </div>
    </div>
  );
}
